import React from 'react'
import CertificationTable from '../components/Certification/certification page/CertificationTable'

const CertificationPage = () => {
  return (
    <div>
      <CertificationTable/>
    </div>
  )
}

export default CertificationPage
